import { render } from "./PatientDocuments.vue?vue&type=template&id=57fbb740"
import script from "./PatientDocuments.vue?vue&type=script&lang=js"
export * from "./PatientDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__